import { oc } from '@orpc/contract';
import { shareOfferInputSchema, shareOfferOutputSchema } from '../schemas/estimates.schemas.js';
/**
 * Records the number the customer was told (plan §5.6): `cta_offer`, `offer_shared_at`, status
 * `OFFER_SHARED`, an automatic snapshot with trigger `OFFER_SHARED` and an activity row. The offer
 * defaults to the calculated ceiling, and an offer above it is recorded with `aboveCeiling` set — the
 * approval gates the *purchase*, not the conversation.
 */
export const shareEstimateOfferContract = oc
    .route({
    method: 'POST',
    path: '/estimates/{estimateId}/offer',
    tags: ['Estimates'],
    summary: 'Share or record CTA’s offer',
})
    .input(shareOfferInputSchema)
    .output(shareOfferOutputSchema);
//# sourceMappingURL=share-estimate-offer.contract.js.map